"use strict";

CompanyUserLinksCtrl.$inject = [
  '$scope',
  '$stateParams',
  'link',
  'index'
];

function CompanyUserLinksCtrl(
  $scope,
  $stateParams,
  link,
  index) {

  $scope.isEdit = false;
  if (link) {
    $scope.shortcut = link;
    $scope.isEdit = true;
  }

  $scope.saveUserLink = function(shortcut) {
    if (!$scope.isEdit) {
      $scope.userLinks.push(shortcut);
    } else {
      $scope.userInfo.features.userLinks[index] = shortcut;
    }

    $scope.userInfo.features.userLinks = $scope.userLinks;
    $scope.userInfo.$update({companyId: $stateParams.companyId, userId: $scope.userInfo.id});
  };

  $scope.deleteUserLink = function() {
    $scope.userLinks.splice(index, 1);
    $scope.userInfo.features.userLinks = $scope.userLinks;
    $scope.userInfo.$update({companyId: $stateParams.companyId, userId: $scope.userInfo.id});
    $scope.$hide();
  };

}


angular.module('dokiv')
  .controller('CompanyUserLinksCtrl', CompanyUserLinksCtrl);


//////////////////
// WEBPACK FOOTER
// ./scripts/company/publications/CompanyUserLinksCtrl.js
// module id = 63
// module chunks = 0